import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { Button } from '@material-ui/core';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import services from '../services';
import tokenService from '../../../Common/tokenDecoder';
import groupService from '../../Group/services';
import _, { forEach, set } from 'lodash';
import xlsx from 'json-as-xlsx';

export const DivisionListing = ({ divisionData, handleClick, editEnabled}) => {
    
    const [division, setDivision] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState();

    const contentRowNames = ["collectionPointCode", "collectionPointName", "isActive"];
    const csvHeaders = [
        { label: "Division Code", value: "collectionPointCode" },
        { label: "Division Name ", value: "collectionPointName" },
    ];
    useEffect(() => {
        trackPromise(
            getGroupsForDropdown()
            )
    }, [])

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [division[0]]);

    useEffect(() => {
        trackPromise(
            DivisionData()
            )
    }, [divisionData]); 

    async function DivisionData() {
        destroyDataTable();
        await setDivision(divisionData);
        createDataTable();
        setCsvData();
    }

        
    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(division[0].groupID)
        setOperationEntities(result)
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ?
                (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                : <td key={index}>{da[row] + " "}</td>
            )
        )
    });

    function createFile() {
        var settings = {
            sheetName: 'Division',
            fileName: 'Division',
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(division)
        var newRow1 = {
            collectionPointCode: "Group :" + groups[division[0].groupID],
            collectionPointName: "Estate : " + operationEntities[division[0].operationEntityID]
         }
        var newRow2 = {
             collectionPointCode: "Generated date/time : " + new Date().toLocaleString(),
             collectionPointName: "Generated user : " + tokenService.getUserNameFromToken()
        }

        // Add newRow1 and newRow2 to copyOfCsv
        copyOfCsv.push({}, {}, newRow1, newRow2);

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    return (
        <Fragment>
        <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">                   
                    <div className="card-body">
                    {division.length > 0 ?                                                
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Division Code</th>
                                        <th>Division Name</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {division.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            {editEnabled ? <td>
                                                <div class="btn-group">
                                                    <Button onClick={() => handleClick(data)} style={{ cursor: "pointer" }}> <i class="far fa-edit"></i></Button>
                                                 </div>

                                            </td> : null}
                                        </tr>
                                    );
                                })}
                            </tbody>
                            </table>
                            <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                    </div>
                        </div>: null}
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )

}